<template>
  <div>
    <el-row>
      <h5 style="color: #C0C4CC;">下单商品</h5>
      <el-table :data="selectOrderTableData" row-key="sid" :show-header="false" :row-style="{ color: 'red' }">
        <el-table-column label="序号" align="center" width="50" type="index" />
        <el-table-column prop="cgoodsSku" align="center" label="SKU" width="90" />
        <el-table-column label="图片" align="center" width="70">
          <template #default="scope">
            <el-image v-if="scope.row.cmasterUrl != null" :preview-src-list="[scope.row.cmasterUrl]" class="w30 h30" :src="scope.row.cmasterUrl"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="商品编码" align="center" width="130" prop="cgoodsBarcode" />
        <el-table-column label="商品名称" align="center" prop="cgoodsName" />
        <el-table-column label="单位" align="center" width="50" />
        <el-table-column label="单价" align="center" width="100">
          <template slot-scope="scope">
            <div>￥ {{ (scope.row.dgoodsPrice / 100).toFixed(2) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="数量" prop="ngoodsNum" align="center" width="130" />
      </el-table>
    </el-row>
    <el-row>
      <h5 style="color: #C0C4CC;">替换货品</h5>
      <el-table :data="replaceTableData" :show-header="false" :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
        <el-table-column label="序号" align="center" width="50" type="index" />
        <el-table-column align="center" label="SKU" width="90" prop="c_barcode"/>
        <el-table-column label="图片" align="center" width="70">
          <template #default="scope">
            <el-image v-if="scope.row.c_master_url != null" :preview-src-list="[scope.row.c_master_url]" class="w50 h50" :src="scope.row.c_master_url"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="货品编码" align="center" width="130" prop="c_sku" />
        <el-table-column label="货品名称" align="center" prop="c_name" />
        <el-table-column label="单位" align="center" width="50" />
        <el-table-column label="单价" align="center" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.n_price">￥ {{ scope.row.n_price }}</div>
          </template>
        </el-table-column>
        <el-table-column label="库位" align="center" width="70" prop="c_num" />
        <el-table-column label="数量" align="center" width="130" prop="c_name" />
        <el-table-column label="可用库存" align="center" width="60">
          <template slot-scope="scope">
            <div class="hHP wHP flex marginLeft10" style="white-space: break-spaces;">
              {{ formatSurplus(scope.row) }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <div class="flex alignItemsCenter marginTop10" style="justify-content: space-between; flex: 1">
      <div></div>
      <div>
        <el-button @click="handleClose">关闭</el-button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "OrderGoodsAdd",
  props: {
    orderTableData: {
      type: Array,
      default: () => [],
    },
    pickTableData: {
      type: Array,
      default: () => [],
    },
    orderDetailIds: {
      type: String,
      default: () => "",
    }
  },
  data() {
    return {
      selectOrderTableData: [],
      replaceTableData: [],
      //商品列表
      options: [],
      selectValue: ''
    };
  },
  created() {
    let ids = this.orderDetailIds.split(',');
    let arr = [];
    for (let i = 0; i < this.orderTableData.length; i++) {
      if (ids.includes(this.orderTableData[i].sid)) {
        arr.push(this.orderTableData[i]);
      }
    }
    this.selectOrderTableData = arr;
    let replaceArr = [];
    for (let i = 0; i < this.pickTableData.length; i++) {
      let needAdd = false;
      let itemIds = this.pickTableData[i].rplatformOrderDetail.split(',');
      for (let j = 0; j < itemIds.length; j++) {
        if (ids.includes(itemIds[j])) {
          needAdd = true;
          break;
        }
      }
      if (needAdd) {
        replaceArr.push(this.pickTableData[i]);
      }
    }
    this.replaceTableData = replaceArr;
  },
  methods: {
    handleClose() {
      this.$emit("handleClose");
    },
    formatSurplus(row) {
      return row.n_surplus < 0 ? 0 : row.n_surplus;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-input__inner {
  border: none !important;
  box-shadow: none !important;
}
.newOrderGoodsAdd {
  height: 600px;
  background-color: white;
  display: flex;
  flex-direction: column;



  .el-tabs__item {
    padding: 0 10px;
  }

  .el-tabs__item.is-active {
    text-decoration: underline;
  }


  .el-popper[x-placement^="bottom"] {
    margin-left: -40px;
  }
}

//.orderGoodsAdd {
//  height: 500px;
//  background-color: white;
//  display: flex;
//  flex-direction: column;
//
//  &__top {
//    flex: 1;
//  }
//
//  &__bottom {
//    height: 50px;
//    line-height: 50px;
//    text-align: right;
//  }
//
//  .el-input {
//    width: 120px;
//  }
//
//  .cell {
//    & > div {
//      width: 120px;
//    }
//  }
//}
</style>
